import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente único do React Query (singleton de módulo — NUNCA criar dentro de um
 * componente, senão o cache é descartado a cada render).
 *
 * Defaults afinados para uma dashboard analítica (não é tempo-real):
 * - staleTime alto evita refetch ao trocar de tab/view/filtro repetidamente;
 * - gcTime longo mantém o cache ao voltar para uma tab;
 * - sem refetch no focus (um analista alterna janelas o tempo todo);
 * - 1 retry (endpoints pesados);
 * - erros viram estado de UI (ChartState), não error boundary.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      throwOnError: false,
    },
  },
});
